import React, { useState } from 'react'
import "./profile_styles/profilepage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { storage, usersRef } from '../../firebase';
import { useDispatch, useSelector } from 'react-redux';
import LoadingPage from '../LoadingPage';
import swal from 'sweetalert';
import swal2 from 'sweetalert2';
import { setUserLoginData } from '../../reduxContainer/StateActions';

export const uploadProfileImage = async (profileImageUpload, email_id, displayName) => {
    if (!profileImageUpload) {
        return Promise.reject("No file selected");
    }
    const newFilename = `${displayName}`;
    const imageRef = storage.ref(`/images/profileImage/${email_id}/${newFilename}`);

    // Upload new image with new filename
    await imageRef.put(profileImageUpload);

    // Get the web URL of the uploaded image
    const downloadURL = await imageRef.getDownloadURL();
    // console.log("Image URL:", downloadURL);

    // Store filename and email id in Firestore database
    await usersRef.doc(email_id).set({
        profileImage_path: downloadURL
    }, { merge: true });
    return downloadURL;
}

const ProfilePage = () => {
    const [profileImageUpload, setProfileImageUpload] = useState(null);
    const usersData = useSelector((state) => state.userData);
    const dispatch = useDispatch();

    const handleLogout = () => {
        swal2.fire({
            title: "Are you sure?",
            text: "Are you sure you want to Log Out?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, Log Out!",
            // closeOnConfirm: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                await swal2.fire({
                    icon: 'success',
                    title: `Logged Out!`,
                    showConfirmButton: false,
                    timer: 1500
                })
                localStorage.removeItem("InfyMailBoxAppToken");
                window.location.reload();
            }
        });
    };

    // profile image save 
    const handleSave = () => {
        uploadProfileImage(profileImageUpload, usersData.email, usersData.displayName)
            .then((image_path) => {
                const updatedUserData = { ...usersData, photoURL: image_path };
                dispatch(setUserLoginData(updatedUserData));
                swal2.fire({
                    icon: 'success',
                    title: `Profile Image Changed !`,
                    showConfirmButton: false,
                    timer: 1500
                })
            })
            .catch((error) => {
                swal("Error", "Something went wrong !", "warning");
            });
    }


    // profile name change save
    const handleProfileNameChange = async () => {
        try {
            const { value: name } = await swal2.fire({
                title: 'Enter Your Name',
                input: 'text',
                inputLabel: 'Your Name',
                inputValue: '',
                inputAttributes: {
                    maxlength: 20,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                },
                showCancelButton: true
            });

            if (name) {
                await usersRef.doc(usersData.email).set({ displayName: name }, { merge: true });
                const updatedUserData = { ...usersData, displayName: name };
                dispatch(setUserLoginData(updatedUserData));
                swal2.fire({
                    icon: 'success',
                    title: `Name is Changed!`,
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        } catch (error) {
            console.log(error);
            swal2.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!'
            });
        }
    };


    return (
        <>
            {
                usersData.displayName && usersData.email && usersData.photoURL ?
                    <div className='profilepage_container'>
                        <div className='profile_container'>
                            <div className='profile_image_container'>
                                <img src={profileImageUpload ? URL.createObjectURL(profileImageUpload) : usersData.photoURL} alt="profileImage" className='profile_image' />
                                <div className='change_image_container'>
                                    <span>
                                        <label htmlFor="file-upload" className="custom-file-upload">
                                            <FontAwesomeIcon icon={faCamera} className='cam_icon' />
                                            Change Profile Image
                                        </label>
                                        <input id="file-upload" type="file" onChange={(event) => {
                                            setProfileImageUpload(event.target.files[0]);
                                        }} />
                                    </span>
                                    <button onClick={handleSave} className='save_btn'>Save</button>
                                </div>
                            </div>
                            <div className='user_data_container'>
                                <div className='profile_name_container'>
                                    <h3>Name : {usersData.displayName}</h3>
                                    <span onClick={handleProfileNameChange}>
                                        <FontAwesomeIcon icon={faPenToSquare} className='edit_icon' />
                                    </span>
                                </div>
                                <h3>Email : {usersData.email}</h3>
                                <button className='logout_btn' onClick={handleLogout}>Log Out</button>
                            </div>
                        </div>
                    </div>
                    : <LoadingPage />
            }

        </>
    )
}

export default ProfilePage